import { render, staticRenderFns } from "./EscalaNyha.vue?vue&type=template&id=5d5d87c7"
import script from "./EscalaNyha.vue?vue&type=script&lang=js"
export * from "./EscalaNyha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports